import newSpPriorityDialogTemplate from './newSpPriorityDialog.html';
import newSpPriorityFormTemplate from './newSpPriorityForm.html';

angular
   .module('org.saga.newsppriority', ['org.saga.service', 'isolateForm'])
   .directive('newSpPriority', [
      function () {
         return {
            restrict: 'E',
            template: newSpPriorityFormTemplate,
            scope: {
               newPriority: '=',
               newPriorityForm: '=',
            },
            controller: [
               '$scope',
               function ($scope) {}
            ]
         };
      }
   ])

   .factory('NewSpPriorityDialog', [
      '$mdDialog',
      function ($mdDialog) {
         return {
            show: function (
               priority,
               callback
            ) {
               function DialogController($scope, $log, $mdDialog) {
                  $scope.priority = priority;
                  $scope.cancel = function () {
                     $mdDialog.cancel();
                  };

                  $scope.ok = function () {
                     $scope.error = false;

                     $mdDialog.hide($scope.priority);
                  };
               }

               $mdDialog
                  .show({
                     controller: ['$scope', '$log', '$mdDialog', DialogController],
                     template: newSpPriorityDialogTemplate,
                     parent: angular.element(document.body),
                     clickOutsideToClose: false
                  })
                  .then(
                     function (answer) {
                        callback(answer);
                     },
                     function () {
                        // callback is not called
                     }
                  );
            }
         };
      }
   ]);
